/* require("@eagleeye-jssdk/loader/zuzuche");
process.env.NODE_ENV === "production" &&
  ea("config", {
    project: "ercp-login",
    environment: DEPLOY_ENV || "dev"
  }); */

import Vue from 'vue'
import interLogin from './interLogin.vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
require('element-ui/lib/theme-chalk/index.css')

import {
  Dialog,
  Input,
  Button,
  Form,
  FormItem,
  Alert,
  Icon,
  Row,
  Col,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Notification,
  Popover,
  Tabs,
  TabPane,
  Card
} from 'element-ui'

Vue.use(Dialog)
Vue.use(Input)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Alert)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Card)
Vue.use(Loading)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.config.productionTip = false
// 在生产环境中让sentry报错 pr
process.env.NODE_ENV === 'production' &&
  Sentry.init({
    dsn: 'https://461c40d9f5ee4cd6ab0ac9af1f8d67f7@logger2.zuzuche.com/24',
    release: DEPLOY_RELEASE || 'dev',
    environment: DEPLOY_ENV || 'dev',
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
        logErrors: true
      })
    ]
    /* beforeSend(event) {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception) {
      Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  } */
  })

new Vue({
  render: h => h(interLogin)
}).$mount('#app')
